import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError, empty } from "rxjs";
import { AuthService } from "../../services/auth.service";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService, private router: Router) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.auth.getToken();
    if (token) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return next.handle(req).pipe(
      catchError((error) => {
        return this.handleError(error);
      })
    );
  }

  handleError(error) {
    if (
      error.status === 401 &&
      (error.error && error.error.message) === "session-expired"
    ) {
      this.auth.logout();
      this.router.navigate(["/login"]);
      return empty();
    }
    return throwError(error);
  }
}
